import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import type { NearMissPageResult } from '@taptimize/shared/dist/review/near-miss-searches';

/**
 * The searches one page is close on, for the review surface's "You're close on these searches" card
 * (`GET /urls/near-miss-searches`; rules in shared/src/review/near-miss-card.ts). The server-side
 * replay reads the same result (`review-page-sources.ts`). Per page, not cached: each page asks once.
 */
@Injectable({ providedIn: 'root' })
export class NearMissSearchesService {
  private readonly API_URL = environment.apiUrl + '/v1';

  constructor(private http: HttpClient) {}

  /** The page's result, or null when the read failed or the page has no analysis. */
  getForPage(domain: string, urlId: string): Observable<NearMissPageResult | null> {
    return this.http
      .get<{ success: boolean; data: NearMissPageResult | null }>(`${this.API_URL}/urls/near-miss-searches`, {
        params: { domain: (domain || '').trim().toLowerCase(), urlId }
      })
      .pipe(
        map((res) => res?.data ?? null),
        catchError(() => of(null))
      );
  }
}
